<template>
  <div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_IS_STRING">
      <InformeAuditoriaFieldString
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldString>
      <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_IS_NUMERICAL">
      <InformeAuditoriaFieldNumerical
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldNumerical>
      <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_IS_PHONE">
      <InformeAuditoriaFieldPhone
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldPhone>
      <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_IS_EMAIL">
      <InformeAuditoriaFieldEmail
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canViewComments="canViewComments"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldEmail>
      <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_IS_ARBITRO">
      <InformeAuditoriaFieldArbitro
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldArbitro>
      <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_IS_DIRECTOR">
      <InformeAuditoriaFieldDirector
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldDirector>
      <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_IS_ESTADIO">
      <InformeAuditoriaFieldEstadio
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldEstadio>
      <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_IS_FECHA">
      <InformeAuditoriaFieldFecha
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldFecha>
      <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_IS_PARTIDO">
      <InformeAuditoriaFieldPartido
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldPartido>
      <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_IS_TORNEO">
      <InformeAuditoriaFieldTorneo
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldTorneo>
      <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_IS_EQUIPO_LOCAL">
      <InformeAuditoriaFieldEquipoLocal
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldEquipoLocal>
      <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div
      v-if="field.dataType.id === Constants.INFORME_FIELD_IS_EQUIPO_VISITANTE"
    >
      <InformeAuditoriaFieldEquipoVisitante
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldEquipoVisitante>
        <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_IS_BOOLEAN">
      <InformeAuditoriaFieldBoolean
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldBoolean>
        <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_IS_SI_NO_NA">
      <InformeAuditoriaFieldSiNoNA
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldSiNoNA>
        <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_IS_DATE">
      <InformeAuditoriaFieldDate
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldDate>
        <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_IS_TIME">
      <InformeAuditoriaFieldTime
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldTime>
        <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_IS_TEXTO_LARGO">
      <InformeAuditoriaFieldTextoLargo
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldTextoLargo>
        <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_FOTO">
      <InformeAuditoriaFieldFoto
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldFoto>
        <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
     <div v-if="field.dataType.id === Constants.INFORME_FIELD_IS_TIME_MANUAL">
      <InformeAuditoriaFieldTimeManual
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldTimeManual>
        <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_IS_CONTACTO_OPERATIVO">
      <InformeAuditoriaFieldContactoOperativo
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        :listClubesContactos="getClubesContactos"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldContactoOperativo>
        <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_ARBITRO_RESERVA">
      <InformeAuditoriaFieldArbitro
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        reserva
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldArbitro>
        <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_ESTADIO_RESERVA">
      <InformeAuditoriaFieldEstadio
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        reserva
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldEstadio>
        <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
    <div v-if="field.dataType.id === Constants.INFORME_FIELD_OFICIAL_SEGURIDAD">
      <InformeAuditoriaFieldOficialSeguridad
        :field="field"
        :can-edit="canEdit"
        :canChangeCheckbox="canChangeCheckbox"
        :canChangeSanctions="canChangeSanctions"
        :canViewSanction="canViewSanction"
        :canViewComments="canViewComments"
        :canViewCorrection="canViewCorrection"
        :canAddComments="canAddComments"
        :canViewCarousel="canViewCarousel"
        @updateField="updaField"
        :label="field.description"
        :index="index"
      ></InformeAuditoriaFieldOficialSeguridad>
      <AlertCompleteField :alertIsActive="checkInputValue" :fieldType="checkInputDataType"></AlertCompleteField>
      <v-divider :color="color" class="mx-4"></v-divider>
    </div>
  </div>
</template>

<script>
import { s3UploadMixin } from '../../../mixins/s3UploadMixin'
import Constants from '../../../common/constants'
import InformeAuditoriaFieldString from './fields_components/InformeAuditoriaFieldString'
import InformeAuditoriaFieldNumerical from './fields_components/InformeAuditoriaFieldNumerical'
import InformeAuditoriaFieldPhone from './fields_components/InformeAuditoriaFieldPhone'
import InformeAuditoriaFieldEmail from './fields_components/InformeAuditoriaFieldEmail'
import InformeAuditoriaFieldArbitro from './fields_components/InformeAuditoriaFieldArbitro'
import InformeAuditoriaFieldDirector from './fields_components/InformeAuditoriaFieldDirector'
import InformeAuditoriaFieldEstadio from './fields_components/InformeAuditoriaFieldEstadio'
import InformeAuditoriaFieldEquipoLocal from './fields_components/InformeAuditoriaFieldEquipoLocal'
import InformeAuditoriaFieldEquipoVisitante from './fields_components/InformeAuditoriaFieldEquipoVisitante'
import InformeAuditoriaFieldFecha from './fields_components/InformeAuditoriaFieldFecha'
import InformeAuditoriaFieldPartido from './fields_components/InformeAuditoriaFieldPartido'
import InformeAuditoriaFieldTorneo from './fields_components/InformeAuditoriaFieldTorneo'
import InformeAuditoriaFieldBoolean from './fields_components/InformeAuditoriaFieldBoolean'
import InformeAuditoriaFieldDate from './fields_components/InformeAuditoriaFieldDate'
import InformeAuditoriaFieldTime from './fields_components/InformeAuditoriaFieldTime'
import InformeAuditoriaFieldTextoLargo from './fields_components/InformeAuditoriaFieldTextoLargo'
import InformeAuditoriaFieldFoto from './fields_components/InformeAuditoriaFieldFoto'
import InformeAuditoriaFieldTimeManual from './fields_components/InformeAuditoriaFieldTimeManual'
import InformeAuditoriaFieldContactoOperativo from './fields_components/InformeAuditoriaFieldContactoOperativo'
import InformeAuditoriaFieldSiNoNA from './fields_components/InformeAuditoriaFieldSiNoNA'
import AlertCompleteField from './fields_components/AlertCompleteField.vue'
import InformeAuditoriaFieldOficialSeguridad from './fields_components/InformeAuditoriaFieldOficialSeguridad.vue'

export default {
  mixins: [s3UploadMixin],
  props: {
    field: Object,
    status: null,
    index: null,
    username: null,
    listClubesContactos: null,
    mandatoryFieldsAreComplete: null
  },
  data () {
    return {
      isMounted: false,
      Constants,
      color: '5487d3'
    }
  },
  computed: {
    canEdit () {
      return (
        (this.status === Constants.INFORME_STATUS_EN_CARGA &&
          this.$store.state.permissions.canPresentInformesAuditorias) ||
        (this.status === Constants.INFORME_STATUS_DEVUELTA &&
          this.$store.state.permissions.canPresentInformesAuditorias)
      )
    },
    canChangeCheckbox () {
      return (
        this.status === Constants.INFORME_STATUS_PRESENTADO &&
        this.$store.state.permissions.canApproveInformesAuditorias
      )
    },
    canChangeSanctions () {
      return (
        this.status === Constants.INFORME_STATUS_PRESENTADO &&
        this.$store.state.permissions.canApproveInformesAuditorias
      )
    },
    canViewComments () {
      return (
        this.status !== Constants.INFORME_STATUS_EN_CARGA &&
        (this.$store.state.permissions.canApproveInformesAuditorias ||
          this.$store.state.authUser === this.username)
      )
    },
    canViewCorrection () {
      return (
        this.status !== Constants.INFORME_STATUS_EN_CARGA && this.status !== Constants.INFORME_STATUS_APROBADO
      )
    },
    canViewSanction () {
      return (this.status === Constants.INFORME_STATUS_APROBADO && this.$store.state.permissions.canApproveInformesAuditorias)
    },
    canAddComments () {
      return (this.status !== Constants.INFORME_STATUS_APROBADO)
    },
    canViewCarousel () {
      return (this.status === Constants.INFORME_STATUS_APROBADO || this.status === Constants.INFORME_STATUS_PRESENTADO)
    },
    getClubesContactos () {
      return this.listClubesContactos
    },
    checkInputValue () {
      // console.log(this.mandatoryFieldsAreComplete)
      // mandatoryFieldsAreComplete es la validacion que utiliza cuando se da al boton presentar y hay campos obligatorios
      // vacios
      if (
        this.mandatoryFieldsAreComplete === false && ((this.field.mandatory && this.field.responseValue === '') ||
          (this.field.requireScale && this.field.scaleValue === ''))
      ) {
        return true
      } else {
        return false
      }
    },
    checkInputDataType () {
      let types = { response: false, scale: false }
      if (this.field.mandatory && this.field.responseValue === '') {
        types.response = true
      }
      if (this.field.requireScale && this.field.scaleValue === '') {
        types.scale = true
      }
      return types
    }
  },
  methods: {
    updaField (updatedField) {
      this.$emit('updateListField', updatedField)
    }

  },
  components: {
    InformeAuditoriaFieldString,
    InformeAuditoriaFieldNumerical,
    InformeAuditoriaFieldPhone,
    InformeAuditoriaFieldEmail,
    InformeAuditoriaFieldArbitro,
    InformeAuditoriaFieldDirector,
    InformeAuditoriaFieldEstadio,
    InformeAuditoriaFieldEquipoLocal,
    InformeAuditoriaFieldEquipoVisitante,
    InformeAuditoriaFieldFecha,
    InformeAuditoriaFieldPartido,
    InformeAuditoriaFieldTorneo,
    InformeAuditoriaFieldBoolean,
    InformeAuditoriaFieldDate,
    InformeAuditoriaFieldTime,
    InformeAuditoriaFieldTextoLargo,
    InformeAuditoriaFieldFoto,
    InformeAuditoriaFieldTimeManual,
    InformeAuditoriaFieldContactoOperativo,
    InformeAuditoriaFieldSiNoNA,
    AlertCompleteField,
    InformeAuditoriaFieldOficialSeguridad
  },
  mounted () {
    this.isMounted = true
  }
}
</script>
